import { printBrowserAdapter } from "./adapters/browser";
import { printQZAdapter } from "./adapters/qz";
import { printAndroidBridgeAdapter } from "./adapters/androidBridge";
import { printCleanterAdapter } from "./adapters/cleanter";
import { printTcpAdapter } from "./adapters/tcp";
import { printCloudPrntAdapter } from "./adapters/cloudprnt";

import {
  createPrintJob,
  normalizePrinterProfile,
  PRINT_ADAPTERS,
  PRINT_CONNECTIONS,
} from "./contracts";

const ADAPTERS = {
  [PRINT_ADAPTERS.BROWSER]: printBrowserAdapter,
  [PRINT_ADAPTERS.QZ]: printQZAdapter,
  [PRINT_ADAPTERS.ANDROID_BRIDGE]: printAndroidBridgeAdapter,
  [PRINT_ADAPTERS.CLEANter]: printCleanterAdapter,
  [PRINT_ADAPTERS.TCP]: printTcpAdapter,
  [PRINT_ADAPTERS.CLOUDPRNT]: printCloudPrntAdapter,
};

function resolveAdapter(printer = {}, adapter = "") {
  if (printer?.adapter) {
    return printer.adapter;
  }

  if (adapter) {
    return adapter;
  }

  switch (printer?.connection) {
    case PRINT_CONNECTIONS.QZ_DESKTOP:
      return PRINT_ADAPTERS.QZ;

    case PRINT_CONNECTIONS.BLUETOOTH_ANDROID:
      return PRINT_ADAPTERS.ANDROID_BRIDGE;

    case PRINT_CONNECTIONS.CLEANter:
      return PRINT_ADAPTERS.CLEANter;

    case PRINT_CONNECTIONS.TCP:
      return PRINT_ADAPTERS.TCP;

    case PRINT_CONNECTIONS.CLOUDPRNT:
      return PRINT_ADAPTERS.CLOUDPRNT;

    case PRINT_CONNECTIONS.BROWSER:
    default:
      return PRINT_ADAPTERS.BROWSER;
  }
}

export async function printDocument({
  document = null,
  printer = {},
  adapter = "",
  copies = 1,
} = {}) {
  const resolvedAdapter = resolveAdapter(printer, adapter);

  const normalizedPrinter = normalizePrinterProfile(
    printer,
    resolvedAdapter
  );

  const job = createPrintJob({
    document,
    printer: normalizedPrinter,
    adapter: resolvedAdapter,
    copies,
  });

  const printAdapter = ADAPTERS[job.printer.adapter];

  if (!printAdapter) {
    throw new Error(
      `Printer adapter "${job.printer.adapter}" belum tersedia.`
    );
  }

  return printAdapter({ job });
}

/**
 * Backward-compatible receipt API.
 *
 * Existing callers remain valid:
 *   printReceipt()
 *
 * New callers:
 *   printReceipt({
 *     order,
 *     documentType: "receipt",
 *     printer,
 *   })
 */
export async function printReceipt({
  order = null,
  documentType = "receipt",
  printer = {},
  adapter = "",
  copies = 1,
} = {}) {
  return printDocument({
    document: {
      type: documentType,
      data: order,
      version: 1,
    },
    printer,
    adapter,
    copies,
  });
}

export function getAvailablePrinterAdapters() {
  return Object.keys(ADAPTERS);
}

export function getPrinterAdapter(adapter) {
  return ADAPTERS[adapter] || null;
}
